import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Stage1viewmodeComponent } from './stage1viewmode/stage1viewmode.component';
import { VIEW_MODE } from '@/app/interfaces/view-mode.enum';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { BriefSectionsComponent } from './add-project-module/brief-sections/brief-sections.component';
@Component({
  selector: 'app-project-brief',
  standalone: true,
  imports: [
    Stage1viewmodeComponent,
    CommonModule,
    MatSlideToggleModule,
    MatIconModule,
    MatButtonModule,
    BriefSectionsComponent,
  ],
  templateUrl: './project-brief.component.html',
  styleUrl: './project-brief.component.css',
})
export class ProjectBriefComponent {
  @Input() currentStep!: number;
  @Input() projectId!: number | null;
  @Output() projectIdEmitter = new EventEmitter<number>();
  

  VIEW_MODE = VIEW_MODE;
  mode: VIEW_MODE = VIEW_MODE.EDIT;

  isEditMode = true; // Default to View mode

  handleViewChange($event: any) {
    this.mode = $event;
  }

  toggleMode(): void {
    this.isEditMode = !this.isEditMode;
    if (this.isEditMode) {
      this.mode = VIEW_MODE.EDIT;
    } else {
      this.mode = VIEW_MODE.VIEW;
    }
    console.log('Switched to', this.isEditMode ? 'Edit Mode' : 'View Mode');
  }
  clickEditProjectBrief() {
    localStorage.setItem('isEdit', String(true));
  }

  receiveProjectId(id: number) {
    this.projectId = id;
    this.projectIdEmitter.emit(this.projectId);
  }
}
